<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/117/title-bg.png" alt="" />
      <div class="technological-process">

        <div class="sxcl">
          <img class="top" src="./../assets/imgs/117/title-1.png" alt="" />
          <div class="content">
            在龙泉驿区行政服务范围内，经龙泉驿区人社局审核推荐报上级批准设立博士后科研工作站（分站）、博士后创新实践基地和博士后平台储备单位的企事业单位（以下简称“设站单位”）以及设站单位招收的博士后研究人员。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/117/title-2.png" alt="" />
          <div class="content">
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （一）申领建站资助应满足以下条件:
              </div>
              1．经上级部门批准新设博士后科研平台；<br/> 2．完成制定本单位博士后工作管理办法；<br/> 3．设立专门的管理机构和有专门的工作人员；<br/> 4．有明确可行的博士后研究项目和博士后招收计划。
            </div>
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （二）申领项目资助应满足以下条件：
              </div>
              1．博士后研究人员完成进站手续并在龙泉驿区人社局备案；<br/> 2．博士后研究人员完成开题报告。
            </div>
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （三）申领生活津贴应满足以下条件：
              </div>
              1．博士后研究人员完成进站手续并在龙泉驿区人社局备案；<br/> 2．博士后研究人员完成中期考核后，可申领第一笔生活津贴；<br/> 3．博士后研究人员完成出站考核和出站手续后，可申领第二笔生活津贴。
            </div>
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （四）申领安家补助应满足以下条件：
              </div>
              1．在龙泉驿区人社局备案并完成出站的博士后研究人员；<br/> 2．出站博士后在龙泉驿区购买不小于80平米的住房；<br/> 3．出站博士后留在龙泉驿区创新创业满一年后可申领第一笔安家补助5万元，满两年后可申领第二笔安家补助5万元，满三年后可申领第三笔安家补助10万元。
            </div>
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （五）申领考核奖励应满足以下条件：
              </div>
              设站单位通过每五年开展一次的国家级、省级评估且评估等次为优秀。
            </div>
          </div>
        </div>
        <div class="zccl2">
          <img class="top" src="./../assets/imgs/117/title-3.png" alt="" />
          <div class="content">
            <div class="titleC">
              <div class="circle"></div>
              <div class="font">
                建站资助、项目资助和考核奖励的发放对象为设站单位，生活津贴和安家补助的发放对象为博士后研究人员。
              </div>
            </div>
            <div class="des">
              <div class="title">建站资助</div>
              新设国家级博士后科研工作站（分站）、省级博士后创新实践基地、市级博士后平台储备单位分别给予50万元、30万元、10万元建站资助。经批准，市级平台晋升为省级平台、省级平台晋升为国家级平台的，按各级别资助标准补齐差额部分。
            </div>
            <div class="des">
              <div class="title">项目资助</div>
              博士后研究人员进站后给予15万元一次性科研项目启动经费资助。
            </div>
            <div class="des">
              <div class="title">生活津贴</div>
              博士后研究人员在站期间给予每年8万元生活津贴，资助期为2年。
            </div>
            <div class="des">
              <div class="title">安家补助</div>
              博士后研究人员期满出站后，继续留在龙泉驿区创新创业的，给予总额不超过20万元的安家补助。
            </div>
            <div class="des">
              <div class="title">考核奖励</div>
              对评估等次为优秀的博士后科研工作站（分站）和博士后创新实践基地，按国家级、省级分别给予20万元、10万元一次性奖励。
            </div>
          </div>
        </div>


        <div class="gmlc">
          <img class="top" src="./../assets/imgs/117/title-4.png" alt="" />
          <div class="content">
            <div class="title">
              <div class="circle"></div>
              <div class="font">
                设站单位博士后管理机构安排专门工作人员根据资助项目类别准备正式的书面申请、申请表以及满足申领条件的相关佐证材料，按以下步骤办理：
              </div>
            </div>
            <div class="des mar-t3">
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">1</div>
                  <div class="line-title">单位申请</div>
                </div>
                <div class="line-content">
                  符合申领条件的博士后科研平台和博士后研究人员，依托设站单位按要求备齐材料，向龙泉驿区人社局提出申请。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">2</div>
                  <div class="line-title">部门审核</div>
                </div>
                <div class="line-content">
                  龙泉驿区人社局审核设站单位提交的资料是否完备。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">3</div>
                  <div class="line-title">会议审定</div>
                </div>
                <div class="line-content">
                  经龙泉驿区人社局复审通过后，报区人社局党组会议审定。</div>
              </div>
              <div class="line-item">
              
                <div class="line-top">
                  <div class="line-num">4</div>
                  <div class="line-title">拨付经费</div>
                </div>
                <div class="line-content">
                  审定通过后，龙泉驿区人社局将资助经费划拨至设站单位账户，设站单位根据资助项目类别统筹使用或发放给博士后研究人员。
                </div>
              </div>
              
            </div>
          </div>
        </div>



        <div class="sxcl">
          <img class="top" src="./../assets/imgs/117/title-5.png" alt="" />
          <div class="content" style="font-size: 0.3rem;font-weight: bolder;">
            达到申领条件时设站单位即可向区人社局提出申请。
          </div>
        </div>
        
        <div class="contact">
          <img class="top" src="./../assets/imgs/117/title-6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-84851306">028-84851306</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区人社局专业技术人员管理科
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/116/code.png" />
          <img class="text" src="../assets/imgs/116/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() { },

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-2.3rem);

    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;

        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #E8EEFF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.9rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          color: #4E4E4E;
          font-size: 0.26rem;
          font-weight: normal;

          .title {
            font-weight: bold;
            position: absolute;
            top: -0.6rem;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
            }
          }

        }
      }
    }
    .zccl2 {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #E8EEFF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .titleC {
        font-weight: bold;
        // position: absolute;
        // top: -0.6rem;
        // left: 50%;
        // transform: translateX(-50%);
        width: 100%;
        // height: 0.67rem;
        font-size: 0.3rem;
        color: #333333;  
        // border: 1px solid red;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding-top: 0.39rem;
        .circle {
          width: 0.22rem;
          height: 0.22rem;
          border: 0.06rem solid #FF6D60;
          border-radius: 50%;
          margin-top: 0.05rem;
          margin-right: 0.1rem;
        }
        .font{
          flex: 1;
          text-align: left;
        }
      }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.8rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          .title {
            position: absolute;
            top: -0.4rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.34rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.1rem 0.23rem 0.3rem;
          position: relative;

          .item {
            margin-top: 0.35rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            color: #4E4E4E;
            font-size: 0.26rem;
            font-weight: 500;
            line-height: 0.44rem;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 135%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.1rem;
              top: 0.2rem;
              z-index: 0;

              //   background-color: #739bfe;
            }

            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;
      margin-bottom: 0.8rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
        font-weight: bold;
        // position: absolute;
        // top: -0.6rem;
        // left: 50%;
        // transform: translateX(-50%);
        width: 100%;
        // height: 0.67rem;
        font-size: 0.3rem;
        color: #333333;  
        // border: 1px solid red;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding-top: 0.39rem;
        .circle {
          width: 0.22rem;
          height: 0.22rem;
          border: 0.06rem solid #FF6D60;
          border-radius: 50%;
          margin-top: 0.05rem;
          margin-right: 0.1rem;
        }
        .font{
          flex: 1;
          text-align: left;
        }
      }
        // .title {
        //   font-size: 0.36rem;
        //   font-weight: bold;
        //   color: #333333;
        //   text-align: left;
        //   line-height: 0.5rem;
        // }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;

              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .code {
        width: 1.94rem;
        height: 1.94rem;
      }

      .text {
        height: 1.2rem;
      }
    }
  }
}</style>
